import { baseApi } from "./base.api";

export const contactSettingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchContactSettings: build.query({
      query: (params) => ({ url: "/contact-settings/fetch", method: "GET", params }),
      providesTags: ["ContactSetting"],
    }),
    fetchContactSettingsAll: build.query({
      query: () => ({ url: "/contact-settings/fetch/all", method: "GET" }),
      providesTags: ["ContactSetting"],
    }),
    fetchTrashedContactSettings: build.query({
      query: (params) => ({ url: "/contact-settings/fetch/trashed", method: "GET", params }),
      providesTags: ["ContactSetting"],
    }),
    fetchLatestContactSetting: build.query({
      query: () => ({ url: "/contact-settings/fetch/latest", method: "GET" }),
      providesTags: ["ContactSetting"],
    }),
    fetchContactSettingById: build.query({
      query: (id) => ({ url: `/contact-settings/fetch/${id}`, method: "GET" }),
      providesTags: ["ContactSetting"],
    }),
    createContactSetting: build.mutation({
      query: (body) => ({ url: "/contact-settings/create", method: "POST", body }),
      invalidatesTags: ["ContactSetting"],
    }),
    updateContactSetting: build.mutation({
      query: ({ id, body }) => ({ url: `/contact-settings/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["ContactSetting"],
    }),
    changeContactSettingStatus: build.mutation({
      query: (id) => ({ url: `/contact-settings/status/${id}`, method: "PUT" }),
      invalidatesTags: ["ContactSetting"],
    }),
    restoreContactSetting: build.mutation({
      query: (id) => ({ url: `/contact-settings/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["ContactSetting"],
    }),
    bulkRestoreContactSettings: build.mutation({
      query: (body) => ({ url: "/contact-settings/bulk-restore", method: "POST", body }),
      invalidatesTags: ["ContactSetting"],
    }),
    deleteContactSetting: build.mutation({
      query: (id) => ({ url: `/contact-settings/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["ContactSetting"],
    }),
    bulkDeleteContactSettings: build.mutation({
      query: (body) => ({ url: "/contact-settings/bulk-delete", method: "POST", body }),
      invalidatesTags: ["ContactSetting"],
    }),
    destroyContactSetting: build.mutation({
      query: (id) => ({ url: `/contact-settings/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["ContactSetting"],
    }),
    bulkDestroyContactSettings: build.mutation({
      query: (body) => ({ url: "/contact-settings/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["ContactSetting"],
    }),
  }),
});

export const {
  useFetchContactSettingsQuery,
  useFetchContactSettingsAllQuery,
  useFetchTrashedContactSettingsQuery,
  useFetchLatestContactSettingQuery,
  useFetchContactSettingByIdQuery,
  useCreateContactSettingMutation,
  useUpdateContactSettingMutation,
  useChangeContactSettingStatusMutation,
  useRestoreContactSettingMutation,
  useBulkRestoreContactSettingsMutation,
  useDeleteContactSettingMutation,
  useBulkDeleteContactSettingsMutation,
  useDestroyContactSettingMutation,
  useBulkDestroyContactSettingsMutation,
} = contactSettingsApi;
